import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import tagsApi from '@/features/dashboard/tags/api/tagsApi.ts';
import {
  TAGS_BASE_KEY,
  tagsApiQueryKeys,
} from '@/features/dashboard/tags/api/tagsApi.queryKeys.ts';

export default function useDeleteTag() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => tagsApi.remove(id),
    onSuccess: () => {
      // Deleting a tag cascades to all its assignments — invalidate the
      // whole tags namespace so catalog and per-target queries refresh.
      queryClient.invalidateQueries({ queryKey: [TAGS_BASE_KEY] });
      queryClient.invalidateQueries({ queryKey: tagsApiQueryKeys.all() });
      toast.success('Tag został usunięty');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description: error.message || 'Nie udało się usunąć tagu.',
      });
    },
  });
}
